/**
 * @file Export button for the plain JSON (ID-based) format.
 */

import { DownloadOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { exportPlainJson } from '../controller/import-export-plain';

const ExportPlainJsonButton = () => {
  const onClick = () => {
    exportPlainJson();
  };

  return (
    <Tooltip placement="bottom" title={'Export plain json'}>
      <Button
        className="export-button"
        icon={<DownloadOutlined />}
        onClick={onClick}
        size="large"
      />
    </Tooltip>
  );
};

export default ExportPlainJsonButton;
